import React, { memo, ReactNode } from 'react';
import cl from 'classnames';

import {
  ClassName,
  FetchItemsClearItemsFilters,
  TableViewType
} from '../../../../../types';

import { IndexTableCell } from '../IndexTableCell';
import { IndexTableRow } from '../../../../common/components/tables/IndexTableRow';

import { PureButtonHelper } from '../../../../../helpers/buttons/PureButtonHelper';
import { Translate } from '../../../../../helpers/Translate';

import { stringsKeys } from '../../../../../locales/keys';

interface NoItemsTableRowProps {
  children?: ReactNode;
  onClearFilters?: FetchItemsClearItemsFilters;
  scope?: string;
  tdClassName?: ClassName;
  textClassName?: ClassName;
  viewType?: TableViewType;
}

function NoItemsTableRow({
  children,
  onClearFilters,
  scope,
  tdClassName = 'hover:bg-gray-500 hover:bg-opacity-5 group',
  textClassName,
  viewType
}: NoItemsTableRowProps) {
  return (
    <IndexTableRow scope={scope}>
      <IndexTableCell tdClassName={tdClassName} colSpan={99}>
        <div
          className={cl({
            'px-3 py-2': !viewType || viewType === TableViewType.DEFAULT,
            'px-3 py-0.5': viewType === TableViewType.SLIM
          })}
        >
          <div
            className={
              textClassName ||
              'text-sm sm:text-base dark:text-gray-200 text-gray-900'
            }
          >
            {children || (
              <Translate id={stringsKeys.noItemsMatchYourSearchCriteria} />
            )}
          </div>

          {onClearFilters && (
            <div className="text-xs text-gray-500">
              <span>
                <Translate
                  id={stringsKeys.pleaseAdjustYourFiltersAndTryAgainOr}
                />
                &nbsp;
              </span>
              <PureButtonHelper
                className="dark:text-gray-400 text-gray-600 underline"
                i18nText={stringsKeys.clearFilters}
                onClick={onClearFilters}
              />
            </div>
          )}
        </div>
      </IndexTableCell>
    </IndexTableRow>
  );
}

export default memo<NoItemsTableRowProps>(NoItemsTableRow);
